import * as styles from "./DatePickerContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";
import { pointerAlignOffset } from "@frontend/utils/pointerAlign";

import { useDatePickerContext } from "./DatePicker.context";
import type { DatePickerContentProps } from "./DatePicker.types";
import { DatePickerArrow } from "./DatePickerArrow";
import { DatePickerBackdrop } from "./DatePickerBackdrop";
import { DatePickerMonths } from "./DatePickerMonths";
import { DatePickerPortal } from "./DatePickerPortal";
import { ARROW_SIZES } from "./constants";

const GAP = 4;

export function DatePickerContent({
  className,
  side = "bottom",
  sideOffset,
  align = "center",
  alignOffset,
  positionMethod,
  ...props
}: DatePickerContentProps): JSX.Element {
  const { arrow, size, pointerOffsetRef } = useDatePickerContext();

  return (
    <DatePickerPortal>
      <DatePickerBackdrop />
      <BasePopover.Positioner
        data-slot="date-picker-positioner"
        side={side}
        sideOffset={sideOffset ?? (arrow ? ARROW_SIZES[size] : GAP)}
        align={align}
        alignOffset={alignOffset ?? pointerAlignOffset(pointerOffsetRef, arrow)}
        positionMethod={positionMethod}
        className={styles.positioner}
      >
        <BasePopover.Popup
          data-slot="date-picker-popup"
          className={clsx(styles.popup, className)}
          {...props}
        >
          {arrow && <DatePickerArrow />}
          <DatePickerMonths />
        </BasePopover.Popup>
      </BasePopover.Positioner>
    </DatePickerPortal>
  );
}
